/**
 * @copyright (c) 2015 Groupe PVP
 * @fileoverview Data storage, trigger events when there is a change
 **/
(function ($g) {
    "use strict";
    var Signal = $g.Signal;

    function Data() {
        var change = {};
        Signal.call(this); //Signal est notre ancètre
        var me = this;
        me.change = change;//pouvoir mettre un écouteur sur une propriété spécifique
        var afterChange = new Signal();//Après une séquence de changement
        me.afterChange = afterChange;
        var changes = [];
        var enableAfterChange = true;

        function estObjet(obj) {
            return ({}.toString.apply(obj).indexOf("Object") > -1);
        }

        function setObject(_keyData) {
            if (_keyData instanceof Data) {
                $g.error("Data, nous avons reçu un autre objet data");
                return;
            }
            for (var key in _keyData) {
                setProp(key, _keyData[key]);
            }
        }

        /**
         * Avertir tous les écouteurs qu'il y a un changements
         * @param {type} key
         * @param {type} value
         * @returns {undefined}
         */
        function pushChange(key, sub, value, old) {
            var e = {key: sub?(key+"."+sub):key, data: value, old: old};
            change[key].trigger(e);
            me.trigger(e); 
            if (enableAfterChange) {
                afterChange.trigger([e]);
            } else {
                changes.push(e);                
            }
        }

        function defProp(key, value) {
            Object.defineProperty(me, key, {
                __proto__: null,
                get: function () {
                    return value;
                },
                set: function (newValue) {
                    if (value != newValue) {
                        var old = value;
                        value = newValue;
                        pushChange(key, null, value, old);
                        //change[key].trigger({key: key, data: value, old: old});
                        //me.trigger({key: key, data: value, old: old});
                    }
                },
                enumerable: true,
                configurable: true
            });
            pushChange(key, null, value);
            //change[key].trigger({key: key, data: value});
            //me.trigger({key: key, data: value});
        }

        function setProp(_key, _data) {
            if (change[_key]) {
                me[_key] = _data;
            } else {
                change[_key] = new Signal();
                if (Array.isArray(_data)) {
                    createNewArray(_key, _data);
                } else if (estObjet(_data)) {
                    createNewData(_key, _data);
                } else {
                    defProp(_key, _data);
                }
            }
        }
        
        function createNewArray(_key, _data) {
            var array = new $g.ArrayData();
            array.bind(function(p) {
                pushChange(_key, p.key, p.data, p.old);
            });
            Object.defineProperty(me, _key, {
                __proto__: null,
                get: function () {
                    return array;
                },
                set: function (newValue) {
                    array.set(newValue);
                },
                enumerable: true,
                configurable: true
            });
            array.set(_data);
        }

        function createNewData(_key, _data) {
            var newData = new Data();
            Object.defineProperty(me, _key, {
                __proto__: null,
                get: function () {
                    return newData;
                },
                set: function (newValue) {
                    newData.set(newValue);
                },
                enumerable: true,
                configurable: true
            });
            newData.bind(function (p) {
                pushChange(_key, p.key, p.data, p.old);
            });            
            newData.set(_data);
        }

        /**
         * @param data	data to import in this container
         */
        this.set = function (_keyData, _newValue) {            
            if (changes.length) {
                throw new Error("Il y a des changements avant qu'on commence !");
            }
            enableAfterChange = false;   
            
            // Reçoit un objet de data à parcourir et appliquer?            
            if (estObjet(_keyData)) {
                setObject(_keyData);
            } else {
                setProp(_keyData, _newValue);
            }
            
            enableAfterChange = true;
            if (changes.length) {
                afterChange.trigger(changes);
                changes=[];
            }
            
        };
        
        this.rset = function (key, val) {
            var pt = key.indexOf(".");
            if (pt >= 0) {
                var sub = key.substr(0, pt);
                me.set(sub, {});
                me[sub].rset(key.substr(pt + 1), val);
            } else {
                me.set(key, val);
            }
        };

        this.rget = function (key) {
            var pt = key.indexOf(".");
            if (pt >= 0) {
                var sub = key.substr(0, pt);
                //me.set(sub, {});
                if (me[sub] instanceof Data) {
                    return me[sub].rget(key.substr(pt + 1));
                }
            } else {
                return me.get(key);
            }
        };

        this.get = function (key) {
            if (this[key] || this[key]===0) {
                return this[key];
            }
        };

        /**
         * Inscrémenter une valeur
         * @param string key
         * @param int qt
         * @returns int
         */
        this.inc = function (key, qt) {
            var v = me.get(key)|0;
            v+=qt;
            me.set(key,v);
            return v;
        };

        /**
         * Check if we have requirement
         * @param object items
         * @returns {undefined}
         */
        this.have = function(items) {
            if (typeof items == "string") {
                var r = {};
                r[items]=1;
            }
            for (var k in items) {
                var need = items[k]|0;
                var have = me.rget(k)|0;
                if (have<need) {
                    return false;
                }
            }
            return true;
        };
        
        /**
         * Modification multiple
         * @param {type} items
         * @param {type} m
         * @returns {Boolean}
         */
        this.minc = function(items,m) {
            if (typeof items == "string") {
                var r = {};
                r[items]=1;
            }
            for (var k in items) {
                var i = items[k]|0;
                me.inc(k,i*m);
            }
        };
    }

    $g.Data = Data;
})(PVPGEngine);